import React from 'react';
import { useQuery } from '@apollo/react-hooks';
import { GET_CHANNELS_AND_GROUPS_FOR_PAGE } from '../../../../gql/channels';
import { ChannelGroup } from '../../../../shared/types';
import Loader from 'components/ui/LoadingIndicator';

import ChannelOrderingTable from './components/ChannelOrderingTable';
import ChannelGroupOrderingTable from './components/ChannelGroupOrderingTable';

const ChannelGroupList = (): JSX.Element => {
    const { loading, data, refetch } = useQuery(
        GET_CHANNELS_AND_GROUPS_FOR_PAGE,
        {
            fetchPolicy: 'network-only',
        }
    );

    const channelGroupsFromApi: ChannelGroup[] = data?.channelGroups || [];
    const channelsFromApi = data?.channels || [];

    if (loading) return <Loader />;

    return (
        <>
            <ChannelGroupOrderingTable
                channelGroups={channelGroupsFromApi}
                onRefetch={refetch}
            />
            <ChannelOrderingTable
                channels={channelsFromApi}
                channelGroups={channelGroupsFromApi}
                loading={loading}
                onRefetch={refetch}
            />
        </>
    );
};

export default ChannelGroupList;
